import React, { useState } from 'react';

const SelectPONumberReport = ({ fetchReports, theme }) => {
    const [poNumber, setPONumber] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!poNumber.trim()) {
            setError('Please enter a PO number.');
            return;
        }
        setError('');
        fetchReports(poNumber.trim());
    };

    // Theme-based styling
    const isLightTheme = theme === 'light';
    const inputStyle = {
        padding: '5px',
        textAlign: 'center',
        backgroundColor: isLightTheme ? '#fff' : '#333',
        color: isLightTheme ? '#333' : '#fff',
        width: '100%',
        borderRadius: '3px',
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            justifyContent: 'center',
            alignItems: 'center',
            margin: '20px auto',
            padding: '40px',
            width: '100%',
            border: '2px solid',
            borderRadius: '10px',
            minHeight: '290px',
        }}>
            
            <h2>PO Number Report</h2>

            {/* Input field for PO number */}
            <div style={{ width: '100%' }}>
                <label style={{ 
                    display: 'block', 
                    marginBottom: '5px', 
                    fontSize: '14px', 
                    fontWeight: 'bold' 
                }}>
                    PO Number:
                </label>
                <input
                    type="text"
                    value={poNumber}
                    onChange={(e) => setPONumber(e.target.value)}
                    placeholder="e.g., HH-21082025-001"
                    style={inputStyle}
                />
            </div>

            {/* Submit button */}
            <button
                className="hoverable"
                onClick={handleSubmit}
                style={{
                    padding: '5px 10px',
                    width: '100%',
                    backgroundColor: '#007bff',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                Submit
            </button>

            {error && (
                <p style={{ 
                    color: 'red', 
                    marginTop: '10px',
                    margin: '10px 0 0 0',
                    fontSize: '14px'
                }}>
                    {error}
                </p>
            )}
        </div>
    );
};

export default SelectPONumberReport;
